import axios from 'axios'

const state = {
}

const getters = {
}

const actions = {
    //获取本地全国行政区划边界
    getLocalFileData(file){
        return axios.get(file);
    },
    //获取行政区划数据
    getRegionData({dispatch, commit},adcode){
        return new Promise((resolve,reject)=>{
            axios({
                method:'GET',
                url:'https://geo.datav.aliyun.com/areas_v3/bound/geojson?code='+adcode+'_full'
            }).then(res=>{
                if(res.data.code !== 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.message}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}});
            })
        })
    },
}

const mutations = {
    
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

